import store from '../../../store/store';
import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { ACTION_RULES_URL } from './action-api-urls';
import { ShopActionRule } from './action-types';

export interface GetActionRulesResponse {
  success: boolean;
  message: string | null;
  data: ShopActionRule[] | null;
}

export default async function get_action_rules_api_call(): Promise<
  ShopActionRule[] | null
> {
  try {
    const shopSlug = store.getState().user?.company?.shop_slug;
    const accessToken = store.getState().auth.authorization.accessToken;
    const sellerToken = accessToken?.sellerToken;

    const requestInfo: RequestInfo = {
      url: ACTION_RULES_URL(shopSlug),
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: accessToken.type + ' ' + sellerToken,
      },
    };

    const actionType = 'GET_ACTION_RULES';
    const customMsg = 'Action rules retrieved successfully.';

    const res: any = await asyncHandler(
      requestInfo,
      actionType,
      customMsg,
      false
    );

    const response: GetActionRulesResponse = res?.data;

    if (res?.actionType === actionType && response?.success === true) {
      return response.data;
    } else {
      return null;
    }
  } catch (exception) {
    console.log('Error during get action rules request');
    return null;
  }
}
